import { init } from "./redux-acron";
import DashboardModule from "./DashboardModule";
import AlertsModule from "./AlertsModule";
import SocialModule from "./SocialModule";
import AuthModule from "./AuthModule";
import AppUsersModule from "./AppUsersModule";
import UserModule from "./UserModule";
import ReportsModule from "./ReportsModule";
import CocreationModule from "./CocreationModule";
import ActionPlansModule from "./ActionPlansModule";
import ConfigurationModule from "./ConfigurationModule";

export default init([
  AuthModule,
  DashboardModule,
  SocialModule,
  AlertsModule,
  AppUsersModule,
  UserModule,
  ReportsModule,
  CocreationModule,
  ActionPlansModule,
  ConfigurationModule
]);



// WEBPACK FOOTER //
// ./src/modules/index.js